
import AdUnit from '../components/AdUnit';
import React, { useEffect, useState } from 'react';
import { Check, ShieldCheck } from 'lucide-react';
import useReveal from '../hooks/useReveal';
import { PageHero, FAQList, DisclosureNote } from '../components/shared';
import SaveButton from '../components/SaveButton';
import AffiliateBlock from '../components/AffiliateBlock';
import AdSlot from '../components/AdSlot';
import { VISA_PAGE } from '../mock';
import { fetchFaqs } from '../api';

const Visas = () => {
  const p = VISA_PAGE;
  const [faqs, setFaqs] = useState(p.faqs);
  useReveal([]);
  useEffect(() => {
    fetchFaqs('visas').then((d) => d.length && setFaqs(d)).catch(() => {});
  }, []);
  return (
    <div className="bg-[#F6F1E3]">
      <PageHero image={p.hero} alt="Passport and visa documents" label={p.label} title={p.title} subtitle={p.subtitle} meta={p.meta} />
      <AdUnit slot="inline" />

      <article className="max-w-3xl mx-auto px-5 py-12 space-y-12">
        <div className="reveal flex justify-end">
          <SaveButton variant="pill" item={{ type: 'guide', ref_id: 'guide-visas', title: p.title, subtitle: p.label, to: '/visas-entry' }} />
        </div>
        {/* Short answer */}
        <section className="reveal rounded-2xl bg-[#eef6f4] border border-[#cfe6e1] p-7">
          <h2 className="font-display text-[26px] font-semibold text-[#1B1D21]">The short answer</h2>
          <p className="mt-3 text-[17px] leading-relaxed text-[#3a4f63]">{p.shortAnswer}</p>
        </section>

        {/* Airport checklist */}
        <section className="reveal">
          <h2 className="font-display text-[28px] font-semibold text-[#1B1D21]">What you need at the airport</h2>
          <ul className="mt-5 space-y-3">
            {p.airport.map((item) => (
              <li key={item} className="flex items-start gap-3">
                <span className="mt-0.5 flex items-center justify-center w-6 h-6 rounded-full bg-[#2F663C]/12 text-[#2F663C] shrink-0">
                  <Check className="w-4 h-4" />
                </span>
                <span className="text-[17px] leading-relaxed text-[#3a4f63]">{item}</span>
              </li>
            ))}
          </ul>
        </section>

        {/* Extending */}
        <section className="reveal">
          <h2 className="font-display text-[28px] font-semibold text-[#1B1D21]">Extending your stay</h2>
          <p className="mt-3 text-[17px] leading-relaxed text-[#3a4f63]">{p.extending}</p>
        </section>

        {/* Insurance */}
        <section className="reveal">
          <h2 className="font-display text-[28px] font-semibold text-[#1B1D21]">Travel insurance — worth it</h2>
          <p className="mt-3 text-[17px] leading-relaxed text-[#3a4f63]">{p.insurance}</p>

          <div className="mt-5">
            <DisclosureNote>
              <span className="font-semibold text-[#1B1D21]">Affiliate disclosure:</span> The
              insurance link below is an affiliate link — we may earn a commission if you
              purchase a policy, at no extra cost to you. See our
            </DisclosureNote>
          </div>

          <div className="mt-5 rounded-2xl bg-white border border-[#E6D7A2] p-6 shadow-[0_14px_34px_-26px_rgba(27,29,33,0.5)]">
            <span className="text-[12px] font-semibold tracking-[0.14em] uppercase text-[#92722A]">Example / indicative only</span>
            <div className="mt-2 flex items-start gap-3">
              <ShieldCheck className="w-6 h-6 text-[#2F663C] mt-0.5" />
              <div>
                <h3 className="font-display text-[20px] font-semibold text-[#1B1D21]">Digital-nomad &amp; traveller cover</h3>
                <p className="mt-2 text-[15px] leading-relaxed text-[#4B4F58]">
                  Flexible monthly travel insurance built for long-stay and remote-work
                  travellers, including UAE coverage.
                </p>
              </div>
            </div>
            <div className="mt-4 flex items-center justify-between gap-4 flex-wrap">
              <span className="text-[18px] font-semibold text-[#1B1D21]">from AUD $64 / month <span className="text-[14px] font-normal text-[#6a7d8e]">(indicative)</span></span>
              <button className="btn-sunset rounded-full px-6 py-2.5 text-[14px] font-semibold">Compare plans →</button>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="reveal">
          <h2 className="font-display text-[28px] font-semibold text-[#1B1D21] mb-5">Frequently asked questions</h2>
          <FAQList faqs={faqs} />
        </section>

        {/* Affiliate essentials + Ad */}
        <section className="reveal">
          <AffiliateBlock placement="visas" title="Get arrival-ready" subtitle="Insurance, data and flights for your UAE trip." columns={3} />
        </section>
        <AdSlot slot="inContent" minH={140} className="reveal" />
      </article>
    </div>
  );
};

export default Visas;
